import i18n from '../utils/i18n';

const Form                = document.querySelector( '.form--careers' );
const FormFirstName       = Form && Form.querySelector( '#careers_first_name' );
const FormLastName        = Form && Form.querySelector( '#careers_last_name' );
const FormEmail           = Form && Form.querySelector( '#careers_email' );
const FormPhone           = Form && Form.querySelector( '#careers_phone' );
const FormLinkCv          = Form && Form.querySelector( '#careers_link_cv' );
const FormLinkedinProfile = Form && Form.querySelector( '#careers_linkedin_profile' );
const FormWebsite         = Form && Form.querySelector( '#careers_website' );
const FormJob             = Form && Form.querySelector( '#careers_job' );
const FormNonce           = Form && Form.querySelector( '[name="nonce"]' );
const FormBtnSubmit       = Form && Form.querySelector( '.formsubmit button' );
const BtnSubmitText       = FormBtnSubmit && FormBtnSubmit.querySelector( '.button__text' );
const backupBtnSubmitText = BtnSubmitText && BtnSubmitText.textContent;
const messages            = i18n.forms;
let message               = {};
let FormBox               = Form && [].slice.call( Form.querySelectorAll( '.formbox--focus' ) );
let lang                  = document.documentElement.lang || 'en-US';

switch ( lang ) {
    case 'es-ES':
    case 'es-AR':
        message = messages.es_ar;
    break;
    default:
        message = messages.en_us;
    break;
}

function Constructor() {
    if ( !Form ) return;

    FormBox.forEach( formBox => {
        let formInput = formBox.querySelector( 'input' );
        formInput.addEventListener( 'focus', onFocusIn, false );
        formInput.addEventListener( 'focusout', onFocusOut, false );
    });
    if ( Form ) {
        Form.addEventListener( 'submit', onSubmit, false );
    }
}

function cleanInputError() {
    const fieldset = this.parentNode.parentNode;
    const hint     = fieldset.querySelector( '.formhint' );
    let backupHintText = hint.hasAttribute( 'data-backup-hint' ) && hint.getAttribute( 'data-backup-hint' );

    if( backupHintText ) {
        hint.textContent = backupHintText;
        hint.setAttribute( 'data-backup-hint', '' );
    } else {
        if( fieldset.classList.contains( 'formfield--error' ) ) {
            hint.textContent = '';
        }
    }

    fieldset.classList.remove( 'formfield--error' );
}

function addInputError( input, message ) {
    const fieldset = input.parentNode.parentNode;
    const hint     = fieldset.querySelector( '.formhint' );
    let backupHintText = hint.textContent;

    if( backupHintText && ! fieldset.classList.contains( 'formfield--error' ) ) {
        hint.setAttribute( 'data-backup-hint', backupHintText );
    }

    fieldset.classList.add( 'formfield--error' );
    hint.textContent = message;
}

function isValidName( field ) {
    return field.value.length <= 40;
}

function isValidEmail() {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test( FormEmail.value.toLowerCase() );
}

// https://gist.github.com/dperini/729294
function isValidURL( url, required ) {
    if ( required && isEmpty( url ) ) {
        return false;
    }
    if ( !required && isEmpty( url ) ) {
        return true;
    }
    const re = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    return re.test( url.value );
}

// https://en.wikipedia.org/wiki/E.164
// ponemos un máximo de 25 caracteres por si agrega algún +{prefix} y
// espacios en blanco.
function isValidPhone() {
    const re = /^([0-9 +]{8,25})$/;
    return isEmpty( FormPhone ) ? true : re.test( FormPhone.value.toLowerCase() );
}

function isEmpty( field ) {
    return !field.value || field.value === '' || field.value === undefined;
}

function scrollToError() {
    const formErrror = Form.querySelector( '.formfield--error' );
    window.scrollTo( 0, formErrror.offsetTop - 100 );
}

function showError() {
    setButtonState( FormBtnSubmit, 'error' );
    addInputError( FormBtnSubmit, message.global );
}

function showSuccess() {
    setButtonState( FormBtnSubmit, 'success' );
    cleanInputError.apply( FormBtnSubmit );
    cleanFocusedClass();
    Form.reset();
}

function onSubmit( event ) {
    event.preventDefault();

    let hasError = false;

    if ( isEmpty( FormFirstName ) ) {
        hasError = true;
        addInputError( FormFirstName, message.required );
    } else {
        if ( ! isValidName( FormFirstName ) ) {
            hasError = true;
            addInputError( FormFirstName, message.firstname );
        } else {
            cleanInputError.apply( FormFirstName );
        }
    }

    if ( isEmpty( FormLastName ) ) {
        hasError = true;
        addInputError( FormLastName, message.required );
    } else {
        if ( ! isValidName( FormLastName ) ) {
            hasError = true;
            addInputError( FormLastName, message.lastname );
        } else {
            cleanInputError.apply( FormLastName );
        }
    }

    if ( ! isValidEmail() ) {
        hasError = true;
        addInputError( FormEmail, message.email );
    } else {
        cleanInputError.apply( FormEmail );
    }

    if ( ! isValidPhone() ) {
        hasError = true;
        addInputError( FormPhone, message.phone );
    } else {
        cleanInputError.apply( FormPhone );
    }

    if ( ! isValidURL( FormLinkCv, true ) ) {
        hasError = true;
        addInputError( FormLinkCv, message.url );
    } else {
        cleanInputError.apply( FormLinkCv );
    }

    if ( ! isValidURL( FormLinkedinProfile ) ) {
        hasError = true;
        addInputError( FormLinkedinProfile, message.url );
    } else {
        cleanInputError.apply( FormLinkedinProfile );
    }

    if ( ! isValidURL( FormWebsite ) ) {
        hasError = true;
        addInputError( FormWebsite, message.url );
    } else {
        cleanInputError.apply( FormWebsite );
    }

    if ( hasError ) {
        scrollToError();
        return;
    } else {
        const url = Form.getAttribute( 'action' );
        let queryString = '?';
        queryString += 'firstname=' + FormFirstName.value;
        queryString += '&job=' + FormJob.value;
        queryString += '&lastname=' + FormLastName.value;
        queryString += '&email=' + FormEmail.value;
        queryString += '&phone=' + FormPhone.value;
        queryString += '&linkcv=' + FormLinkCv.value;
        queryString += '&linkedinprofile=' + FormLinkedinProfile.value;
        queryString += '&website=' + FormWebsite.value;
        queryString += '&nonce=' + FormNonce.value;

        const request = new XMLHttpRequest();
        request.onreadystatechange = function() {

            setButtonState( FormBtnSubmit, 'loading' );

            if ( request.readyState == 4 && request.status == 200) {
                let response = JSON.parse( request.response );
                if( response && response.status == 'success' ) {
                    showSuccess();
                }else {
                    showError();
                }
            } else if( request.readyState == 4 && request.status != 200 ) {
                showError();
            }
        }
        request.open( "GET", url + `${queryString}`, true );
        request.send();
    }
    return;
}

function onFocusIn() {
    let fieldType = this.type;
    if ( fieldType === 'checkbox' ) {
        this.parentNode.parentNode.classList.add( 'formbox--focused' );
    } else {
        this.parentNode.classList.add( 'formbox--focused' );
    }
}

function onFocusOut() {
    let field = this;

    if( isEmpty( field ) ) {
        field.parentNode.classList.remove( 'formbox--focused' );
    }
}

function cleanFocusedClass() {
    FormBox.forEach( formBox => {
        formBox.classList.remove( 'formbox--focused' );
    });
}

/**
 * Para que la función se ejecute correctamente el botón input tiene
 * que tener internamente <span> con la clase .button__text para
 * lograr la animación pertinente, por ejemplo:
 *
 * <button type="submit" class="button button--invert">
 *      <span class="button__text">Get in touch</span>
 * </button>
 */
function setButtonState( btn, state ) {

    if( !btn || !BtnSubmitText ) return;

    if( state === 'loading' ) {
        BtnSubmitText.textContent = message.loading;
        btn.classList.add( 'button--loading' );
        btn.disabled = true;
        return;
    }

    if( state === 'success' ) {
        BtnSubmitText.textContent = message.success;
        btn.classList.add( 'button--loaded' );

        setTimeout( function() {
            restoreButtonState( btn, backupBtnSubmitText );
        }, 4000 );
    }

    if( state === 'error' ) {
        restoreButtonState( btn, backupBtnSubmitText );
    }
}

function restoreButtonState( btn, txt ) {
    BtnSubmitText.textContent = txt;
    btn.classList.remove( 'button--loading' );
    btn.classList.remove( 'button--loaded' );
    btn.disabled = false;
}

export default Constructor;